// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'mail-check';

export const Component = () => (
  <path d='M18.152 7.89H1.485a1.41 1.41 0 0 0-1.054.43A1.408 1.408 0 0 0 0 9.374v11.781c0 .432.144.767.431 1.054.288.288.623.432 1.054.432h16.667c.43 0 .766-.144 1.053-.432.288-.287.432-.622.432-1.054V9.375a1.41 1.41 0 0 0-.432-1.055 1.408 1.408 0 0 0-1.053-.43Zm.478 3.591v9.674c0 .336-.143.48-.478.48H1.485c-.335 0-.526-.144-.526-.48v-9.674l7.806 4.98c.287.192.622.288 1.054.288.431 0 .766-.096 1.054-.287l7.758-4.98Zm0-2.107v.958l-8.285 5.316c-.143.097-.287.144-.526.144a.963.963 0 0 1-.527-.144L.96 10.332v-.958c0-.335.191-.479.526-.479h16.667c.335 0 .478.144.478.48Zm5.747-6.513L20.45 6.788a.434.434 0 0 1-.335.144.434.434 0 0 1-.335-.144l-1.964-1.436a.542.542 0 0 1-.143-.383c0-.335.143-.48.479-.48.143 0 .239.048.287.097l1.628 1.198 3.64-3.64A.434.434 0 0 1 24.042 2c.335 0 .48.191.48.527 0 .143-.049.24-.145.335V2.86Z' />
);

export const viewBox = '0 0 25 25';
